@if (title || subtitle) {
    <div class="mb-4">
        @if (title) {
            <h2>{{title}}</h2>
        }
        @if (subtitle) {
            <label>{{subtitle}}</label>
        }
    </div>
}
<div class="w-full">
    <ng-content></ng-content>
</div>